import React from 'react'

export default function Telecommunications() {
  return (
    <div>Telecommunications</div>
  )
}
